module.exports = __webpack_public_path__ + "img/bg-1.b4636bc4.jpeg";